import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_PROJECT_CUSTOMER_GROUP,
  CREATE_PROJECT_CUSTOMER_GROUP,
  FETCH_PROJECT_CUSTOMER_GROUP,
  FETCH_PROJECT_CUSTOMER_GROUP_LIST,
  UPDATE_PROJECT_CUSTOMER_GROUP,
} from './projectCustomerGroup.actions';
import {
  ProjectCustomerGroup,
  ProjectCustomerGroupState,
} from './projectCustomerGroup.types';

const getInitialProjectCustomerGroupState = (): ProjectCustomerGroup => ({});

const initialState: ProjectCustomerGroupState = {
  errorMessage: '',
  item: getInitialProjectCustomerGroupState(),
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: ProjectCustomerGroupState = initialState,
  action: AppAction,
): ProjectCustomerGroupState => {
  switch (action.type) {
    case REQUEST(FETCH_PROJECT_CUSTOMER_GROUP_LIST):
    case REQUEST(CREATE_PROJECT_CUSTOMER_GROUP):
    case REQUEST(FETCH_PROJECT_CUSTOMER_GROUP):
    case REQUEST(UPDATE_PROJECT_CUSTOMER_GROUP):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PROJECT_CUSTOMER_GROUP_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PROJECT_CUSTOMER_GROUP_LIST):
    case FAILURE(CREATE_PROJECT_CUSTOMER_GROUP):
    case FAILURE(FETCH_PROJECT_CUSTOMER_GROUP):
    case FAILURE(UPDATE_PROJECT_CUSTOMER_GROUP):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_PROJECT_CUSTOMER_GROUP):
    case SUCCESS(FETCH_PROJECT_CUSTOMER_GROUP):
    case SUCCESS(UPDATE_PROJECT_CUSTOMER_GROUP):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_PROJECT_CUSTOMER_GROUP:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
